import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const closePeriod = async (periodId) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const { data } = await client.patch(`/current-organization/course-assignment/periods/${periodId}/close`)
  return data
}

export const useClosePeriod = () => {
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: closePeriod,
    hookName: 'useClosePeriod',
    errorMessage: 'Error closing course assignment period',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentPeriodStatus'] })
    }
  })
}
